import { render, staticRenderFns } from "./PactAct.vue?vue&type=template&id=85948830&scoped=true"
import script from "./PactAct.vue?vue&type=script&lang=js"
export * from "./PactAct.vue?vue&type=script&lang=js"
import style0 from "./PactAct.vue?vue&type=style&index=0&id=85948830&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85948830",
  null
  
)

export default component.exports